import { Component, DestroyRef, inject, OnInit, Signal, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { InvoicingService, ISaleStatus } from '../../../core/services/invoicing.service';
import { StoresService } from '../../../core/services/stores.service';
import { UserService } from '../../../core/services/user.service';
import { DatePipe } from '@angular/common';
import { SalesStatusComponent } from '../sales-status/sales-status.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoaderComponent } from '../../../shared-with-client/loader/loader.component';
import { InvoicePreviewComponent } from '../invoice-preview/invoice-preview.component';
import { IconComponent } from '../../../shared-with-client/icon/icon.component';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SaleDetailDocumentsComponent } from "../sale-detail-documents/sale-detail-documents.component";
import { SaleDetailActionsComponent } from "../sale-detail-actions/sale-detail-actions.component";

@Component({
    selector: 'app-sale-details',
    imports: [SalesStatusComponent, TranslatePipe, DatePipe, LoaderComponent, InvoicePreviewComponent, IconComponent, SaleDetailDocumentsComponent, SaleDetailActionsComponent],
    templateUrl: './sale-details.component.html',
    styleUrl: './sale-details.component.scss',
})
export class SaleDetailsComponent implements OnInit {
    private bsModalRef = inject(BsModalRef, { optional: true });
    private dialogRef = inject(DialogRef, { optional: true });
    private dialogData = inject(DIALOG_DATA, { optional: true }) as { sale?: any } | null;
    private bsModalService = inject(BsModalService, { optional: true });

    /** True when opened via CDK Dialog (needs own card chrome). */
    public readonly isCdkDialog = !!this.dialogRef;

    /** Set via ngx-bootstrap `initialState` or CDK `DIALOG_DATA`. */
    public sale: any = this.dialogData?.sale;

    private invoicingService = inject(InvoicingService);
    private storesService = inject(StoresService);
    private userService = inject(UserService);
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    public currentStore: Signal<any> = toSignal(this.storesService.getActiveStore());
    public currentUser: Signal<any> = toSignal(this.userService.currentUser);

    public loadingSaleDetails = signal(true);
    readonly ISaleStatus = ISaleStatus;

    public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());

    public seeInvoicePreview = signal(true);

    ngOnInit(): void {
        this.getSaleDetails(this.sale.id);
    }

    getSaleDetails(id: number) {
        this.loadingSaleDetails.set(true);
        return this.invoicingService.getSaleDetails(id, this.currentStore().id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (res) => {
                    this.sale = res;
                    this.loadingSaleDetails.set(false);
                },
            });
    }

    saleUpdated() {
        this.getSaleDetails(this.sale.id);
        this.bsModalService?.setDismissReason('updated');
        this.dialogRef?.close('updated');
        this.router.navigateByUrl(`${this.currentStore().slug}/dashboard/sales`);
    }

    destroyPreview() {
        this.seeInvoicePreview.set(false);
    }

    close() {
        if (this.dialogRef) {
            this.dialogRef.close();
            return;
        }

        this.bsModalRef?.hide();
    }
}
